import { getBlobSasToken } from './api';

/**
 * Uploads a file to Azure Blob Storage using a short-lived SAS token.
 * Returns the permanent public blob URL.
 */
export async function uploadBlob(file: File, placeId?: string): Promise<string> {
  const ext = file.name.split('.').pop() || 'jpg';
  const { uploadUrl, blobUrl } = await getBlobSasToken(ext, placeId);

  const res = await fetch(uploadUrl, {
    method: 'PUT',
    headers: {
      'x-ms-blob-type': 'BlockBlob',
      'Content-Type': file.type || 'application/octet-stream',
    },
    body: file,
  });

  if (!res.ok) {
    throw new Error(`Blob upload failed: ${res.status} ${res.statusText}`);
  }

  return blobUrl;
}
